<div class="section-header">
    <app-info-icon-button *ngIf="isPrintSmartSupplyAcquisitionType()"
                          [model]="{ title: 'Information',
                           messages: ['An dieser Stelle können Sie Ihre Konditionen für die Verbrauchsmaterialversorgung über unsere maßgeschneiderten PrintSmart-Lösungen anfragen.'],
                           dialogHeight: 100}">
    </app-info-icon-button>
    <div class="title">
        Verbrauchsmaterialbezug
    </div>
</div>

<div>
    <div class="section-header">


        <div class="tab-title">
            Bitte wählen Sie die Konditionen für die Verbrauchsmaterialversorgung:
        </div>

        <!--    this input makes form invalid if  devices accessories and supplies tabs are empty -->
        <app-amount-input [ngModel]="model.someItemContainerIsActive"
                          [showIcon]="false"
                          [name]="'someItemContainerIsActive'"
                          [bdMinNumber]="1"
                          class="validator-helper"
                          [forceFormValidationVisibility]="forceFormValidationVisibility"
                          #validationHelperNgModel="ngModel">
        </app-amount-input>


        <div>
            <app-supply-acquisition-type-input
                [(ngModel)]="model.project.supplyAcquisitionType"
                [name]="'supplyAcquisitionType'"
                class="supply-acquisition-type-input"
                [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLY_ACQUISITION_TYPE),
                            'invalid' : forceFormValidationVisibility && !projectRowItemsAmountComplyRules() && !isSupplyOrderActive()}"
                (ngModelChange)="onSupplyAcquisitionChanged()"
                [isMpsDisabled]="isMpsDisabled()">
            </app-supply-acquisition-type-input>
        </div>

        <bd-input-error-viewer [ngModelRef]="validationHelperNgModel"
                               *ngIf="!isSupplyOrderActive() && !projectRowItemsAmountComplyRules()"
                               [customErrorsMsg]="{'isBdMinNumber': 'Bitte wählen Sie unter Schritt 3, 4 oder 5 mindestens ein Produkt aus.'}"
                               class="error-viewer">
        </bd-input-error-viewer>

        <div class="note" [ngClass]="{'noShopping':!isSupplyOrderActive()}"
             *ngIf="isPrintSmartSupplyAcquisitionType() || !isSupplyOrderActive()">
            {{
                isSupplyOrderActive() ?
                    ' Die von Ihnen ausgewählten MPS-fähigen Geräte wurden automatisch als Auswahl zur Belieferung im MPS' +
                    ' vorgeschlagen. Um weitere MPS-fähige Geräte Ihrer Anfrage hinzuzufügen, können Sie dies auf der vorherigen Seite' +
                    ' (Schritt 3) vornehmen.'
                    : 'Wenn kein Verbrauchsmaterial für dieses Projekt benötigt wird, bitte auf „Weiter“'
            }}
        </div>

        <div class="clearfix" *ngIf="isSupplyOrderActive()">
            <div class="btn-link-container float-right">
                <button class="btn" (click)="onNoSupplyBtnClicked()" type="button">
                    Kein Verbrauchsmaterial anfragen
                </button>
            </div>
        </div>
    </div>


    <ng-container *ngIf="isSupplyOrderActive()">
        <div class="divider"></div>
        <div class="section-header" bdFxLayoutAlign="space-between center">
            <div bdFxFlex="0 0 auto" class="title">
                Bezugszeitraum
            </div>
        </div>


        <div *ngIf="!isPrintSmartSupplyAcquisitionType()">
            <app-labeled-select-distributor-input [label]="'Bezug über*'"
                                                  [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLY_DISTRIBUTOR)}"
                                                  required
                                                  placeholder="Bitte auswählen"
                                                  [values]="getSupplyDistributorValues()"
                                                  [choices]="getSupplyDistributorChoices()"
                                                  [appInvalidValueList]="getInactiveSupplyDistributorIdsList()"
                                                  [forceFormValidationVisibility]="forceFormValidationVisibility"
                                                  name="supplyDistributor"
                                                  [(ngModel)]="model.project.requestedSupplyInfo.supplyDistributorId"
                                                  (ngModelChange)="onProductSupplyDistributorChanged(model.project.requestedSupplyInfo)"
                                                  #productDistributorNgModel="ngModel">
            </app-labeled-select-distributor-input>


            <bd-input-error-viewer [ngModelRef]="productDistributorNgModel"
                                   [customErrorsMsg]="{invalidValue:'Kann nicht inaktiv sein, bitte wählen Sie einen anderen Wert'}">
            </bd-input-error-viewer>

            <app-labeled-select-distributor-input label="Bezug alternativ über"
                                                  placeholder="Optional auswählen"
                                                  [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SECONDARY_SUPPLY_DISTRIBUTOR)}"
                                                  [values]="getSecondarySupplyDistributorValues()"
                                                  [choices]="getSecondarySupplyDistributorChoices()"
                                                  [appInvalidValueList]="getInactiveSupplyDistributorIdsList()"
                                                  [forceFormValidationVisibility]="forceFormValidationVisibility"
                                                  name="secondarySupplyDistributor"
                                                  [(ngModel)]="model.project.requestedSupplyInfo.secondarySupplyDistributorId"
                                                  (ngModelChange)="onSecondarySupplyDistributorChanged(model.project.requestedSupplyInfo, secondarySupplyDistributorNgModel)"
                                                  [appNotSameValueAs]="productDistributorNgModel.value"
                                                  #secondarySupplyDistributorNgModel="ngModel">
            </app-labeled-select-distributor-input>

            <bd-input-error-viewer [ngModelRef]="secondarySupplyDistributorNgModel"
                                   [customErrorsMsg]="{invalidValue:'Kann nicht inaktiv sein, bitte wählen Sie einen anderen Wert',
                                     appNotSameValueAs: 'Bitte Alternative zum ersten Bezug auswählen'}">
            </bd-input-error-viewer>
        </div>


        <div *ngIf="isPrintSmartSupplyAcquisitionType()">

            <bd-labeled-select-input [label]="'Bezug über*'"
                                     [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLY_DISTRIBUTOR)}"
                                     placeholder="Bitte auswählen"
                                     [choices]="getSupplyDistributorMPSChoices()"
                                     [values]="getSupplyDistributorMPSValues()"
                                     [disabled]="true"
                                     name="supplyDistributor"
                                     [(ngModel)]="model.project.requestedSupplyInfo.supplyDistributorId"
                                     #productDistributorNgModel="ngModel">
            </bd-labeled-select-input>


            <bd-input-error-viewer [ngModelRef]="productDistributorNgModel"></bd-input-error-viewer>
        </div>


        <app-info-icon-button
            [model]="{ title: 'Information',
                   messages: ['Bitte geben Sie ein, wann die ersten Verbrauchsmaterialien geliefert werden sollen.'],
                   dialogHeight: 100}">
        </app-info-icon-button>
        <bd-labeled-date-input [label]="'Bezugsbeginn*'"
                               [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLY_ROLLOUT_START)}"
                               required
                               [forceFormValidationVisibility]="forceFormValidationVisibility"
                               name="relationStarts"
                               [(ngModel)]="model.project.requestedSupplyInfo.rolloutStart"
                               [datePickerMinDate]="getRolloutStartMinDay()"
                               [datePickerMaxDate]="editModalService.getNext5YearsDate()"
                               [datePickerDaysDisabled]="[6,0]"
                               [bdMinDate]="getRolloutStartMinDay()"
                               [bdMaxDate]="editModalService.getNext5YearsDate()"
                               appWorkingDay
                               #rolloutStartNgModel="ngModel"
                               (ngModelChange)="onRolloutStartChanged()">
        </bd-labeled-date-input>
        <bd-input-error-viewer [ngModelRef]="rolloutStartNgModel"></bd-input-error-viewer>


        <ng-container *ngIf="isPrintSmartSupplyAcquisitionType()">
            <bd-labeled-select-input [label]="'Vertragslaufzeit (Monate)*'" placeholder="Bitte auswählen"
                                     [ngClass]="{'notify-change' : notifyChange( pUNFEnum.TIME_PERIOD)}"
                                     required
                                     [choices]="getTimePeriodInMonthsChoices()"
                                     [values]="getTimePeriodInMonthsValues()"

                                     [forceFormValidationVisibility]="forceFormValidationVisibility"
                                     name="timePeriodInMonths"
                                     (ngModelChange)="onTimePeriodInMonthsChanged($event)"
                                     [(ngModel)]="model.project.requestedSupplyInfo.timePeriodInMonths"
                                     #timePeriodInMonthsNgModel="ngModel">
            </bd-labeled-select-input>
            <bd-input-error-viewer class="mb-0" [ngModelRef]="timePeriodInMonthsNgModel"></bd-input-error-viewer>
        </ng-container>

        <ng-container *ngIf="!isPrintSmartSupplyAcquisitionType()">
            <app-info-icon-button
                [model]="{ title: 'Information',
                   messages: ['Bitte geben Sie ein, bis zu welchem Zeitpunkt Verbrauchsmaterial geliefert werden soll.'],
                   dialogHeight: 100}">
            </app-info-icon-button>
            <bd-labeled-date-input [label]="'Bezugsende*'"
                                   [ngClass]="{'notify-change' : notifyChange( pUNFEnum.SUPPLY_ROLLOUT_END)}"
                                   name="relationEnds"
                                   [forceFormValidationVisibility]="forceFormValidationVisibility"
                                   [(ngModel)]="model.project.requestedSupplyInfo.rolloutEnd"
                                   required
                                   [datePickerMinDate]="getRolloutEndMinDate(model.project.requestedSupplyInfo.rolloutStart)"
                                   [datePickerMaxDate]="editModalService.getNext5YearsDate()"
                                   [datePickerDaysDisabled]="[6,0]"
                                   [bdMinDate]="getRolloutEndMinDate(model.project.requestedSupplyInfo.rolloutStart)"
                                   [bdMaxDate]="editModalService.getNext5YearsDate()"
                                   appWorkingDay
                                   #rolloutEndNgModel="ngModel"
                                   (ngModelChange)="onRolloutEndChanged()">
            </bd-labeled-date-input>
            <bd-input-error-viewer [ngModelRef]="rolloutEndNgModel"></bd-input-error-viewer>

        </ng-container>

        <div class="divider"></div>
    </ng-container>

</div>


<div class="sections-container" *ngIf="isSupplyOrderActive()">
    <app-projects-print-smart-supplies-shopping-table *ngIf="isPrintSmartSupplyAcquisitionType()">
    </app-projects-print-smart-supplies-shopping-table>

    <app-general-supplies-shopping-table *ngIf="!isPrintSmartSupplyAcquisitionType()"
                                         [forceFormValidationVisibility]="forceFormValidationVisibility">
    </app-general-supplies-shopping-table>

</div>


